
/**
 * Main Script
 */
$(document).ready(function() { 

    // Design-Element für Checkboxen
    $("input[type='checkbox'] + label").prepend("<span></span>");


    // Equal-Height / MatchHeight
    var $equalHeight = $(".equal-height");
    if ($equalHeight.length > 0) {
        $equalHeight.matchHeight();

        // Tabs in Equal-Height Container
        $equalHeight.find("a[data-toggle='tab']").on("shown.bs.tab", function() {
            $.fn.matchHeight._update(); 
        });
    }


    // ContentImage
    var $contentImage = $(".content-image");
    if ($contentImage.length > 0) {
        $(".zoom-icon-link").click(function(e) {
            e.preventDefault();
            $(this).parents(".image-frame").find(".content-image-link").click();
            return false;
        });
    }


    // ----------------------------------------------------------------------------------
    // Ankerpunkte
    // ----------------------------------------------------------------------------------
    $('a[href*="#"]:not([href="#"]):not([data-toggle])').click(function(e) {
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            scrollToTarget(target);
            e.preventDefault();
        }
    });

    // Hash schon beim Laden vorhanden?
    var hash = window.location.hash;
    var target = $(hash);
    scrollToTarget(target);


    function scrollToTarget(target) {
        if (target.length) {
            $('html, body').animate({
                scrollTop: (target.offset().top - 80)
            }, 1000);
            return false;
        }
    }


    // ----------------------------------------------------------------------------------
    // Fancy Input field preparation
    // ----------------------------------------------------------------------------------
    var $fancyInputFieldWrap = $("form").find(".kb-fancy-inputfield");
    if ($fancyInputFieldWrap.length > 0) {
        $fancyInputFieldWrap.find(".form-control").each(function() {
            if ($(this).val().trim().length > 0) {
                $(this).parents(".kb-fancy-inputfield").addClass("has-focus");
            }
            $(this).on("focus", function() { $(this).parents(".kb-fancy-inputfield").addClass("has-focus"); });
            $(this).on("blur", function() {
                if ($(this).val().trim() === "") {
                    $(this).parents(".kb-fancy-inputfield").removeClass("has-focus");
                }
            })
        });
    }


    // ----------------------------------------------------------------------------------
    // Back-To-Top-Button
    // ----------------------------------------------------------------------------------
    var $back2TopButton = $('<a href="#top" class="back2top hidden-xs"></a>').appendTo("body");
    $(window).scroll(function() {
        if (!$("body").hasClass("noscroll") && $(this).scrollTop() > 200) { // Wenn 200 Pixel gescrolled wurde
            $back2TopButton.fadeIn();
        } else {
            $back2TopButton.fadeOut();
        }
    });
    $back2TopButton.hide();
    $back2TopButton.click(function(e) { // Klick auf den Button
        e.preventDefault();
        $('body,html').animate({ scrollTop: 0 }, 500);
        return false;
    });

    // Animation Teaser-Boxen
    $(function() {
        var $list = $('.teaser-list');
        if(($list).is(':visible')) {
            var hoverCnt = $list.find('.overlay');
            hoverCnt.parent().hover(function() {
                var math = (45+$(this).find('.teaser-subtitle').height());
                $(this).find('.overlay').attr('style', 'height:'+math+'px!important;');
            }, function() {
                $(this).find('.overlay').removeAttr('style');
            });
        }
    });

});
